export default __webpack_public_path__ + "static/media/Olim8.0bbe873f.png";